import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
import { allActionsParams } from './models';
var BASE_URL = "".concat(apiUrl, "/action");
export var getAllActions = function getAllActions(params) {
  return getReq(BASE_URL, {
    params: allActionsParams(params)
  });
};
export var getActionFilters = function getActionFilters() {
  return getReq("".concat(BASE_URL, "/filters"));
};
export var getAction = function getAction(id) {
  return getReq("".concat(BASE_URL, "/").concat(id));
};
export var createAction = function createAction(body) {
  return postReq(BASE_URL, body);
};
export var updateAction = function updateAction(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};
export var completeAction = function completeAction(id) {
  return putReq("".concat(BASE_URL, "/").concat(id), {
    status: 'completed'
  });
};
export var snoozeAction = function snoozeAction(id, followUpDate) {
  return putReq("".concat(BASE_URL, "/").concat(id), {
    status: 'snoozed',
    follow_up_date: followUpDate
  });
};
export var getActionEventLog = function getActionEventLog(id) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/events"));
};